/**
 *
 *
 * Sliderable
 *
 * Custom slider for UI interfaces
 *
 */

//const _debounce = require( '../_debounce' );
const $ = require( 'jquery' );

var Sliderable = function(el, options){
    this.$el                = $(el);
    this.$sliderContainer   = this.$el.find( '.sliderable-items-container' );
    this.$sliderItem        = this.$el.find( '.sliderable-item' );
    this.$nextBtn           = this.$el.find(".controls").find(".next-btn");
    this.$prevBtn           = this.$el.find(".controls").find(".prev-btn");

    this.globalDefaults = {
        dots        : false,
        arrows      : false,
        ActiveStart : ''
    };

    this.settings = $.extend( {}, this.globalDefaults, options );



    this.init();
};

Sliderable.prototype.init = function(){

    //check for setting first slide
    if (this.$sliderItem.filter( $('.active') ).length === 0){
        this.$sliderItem.first().addClass("active");
    }


    this.setWidth();
    this.setTransform();
    this.makeDots();

    $(window).resize( function(){
        var resize;

        clearTimeout(resize);

        resize = setTimeout(function(){
            this.setWidth();
            this.setTransform();
        }.bind(this), 150);

    }.bind(this)) ;


    this.$nextBtn.on('click', function(e){
        e.preventDefault();
        this.nextSlide();
    });

    this.$prevBtn.on('click', function(e){
        e.preventDefault();
        this.prevSlide();
    });


};

Sliderable.prototype.setWidth = function(){

    var totalWidth = 0;

    this.$sliderItem.outerWidth( this.$el.outerWidth() );

    this.$sliderItem.each( function(){
        totalWidth += $(this).outerWidth();
    });

    this.$sliderContainer.width(totalWidth);
};

Sliderable.prototype.setTransform = function(){

    var $activeItem = this.getActiveSlide(),
        activeItemOffset = $activeItem.offset().left,
        itemsContainerOffset = this.$sliderContainer.offset().left,
        totalOffset = activeItemOffset - itemsContainerOffset;

    this.$sliderContainer.css({"transform": "translate( -"+totalOffset+"px, 0px)"});

};

Sliderable.prototype.nextSlide = function(){
    var activeItem = this.getActiveSlide(),
        activeItemIndex = activeItem.index(),
        sliderItemTotal = this.$sliderContainer.find(".sliderable-item").length,
        nextSlide = 0;

    if (activeItemIndex + 1 > sliderItemTotal - 1){
        nextSlide = 0;
    }else{
        nextSlide = activeItemIndex + 1
    }

    var nextSlideSelect = this.$sliderContainer.find(".sliderable-item").eq(nextSlide),
        itemContainerOffset = this.$sliderContainer.offset().left,
        totalOffset = nextSlideSelect.offset().left - itemContainerOffset

    this.getActiveSlide().removeClass("active");
    nextSlideSelect.addClass("active");
    $slider.find(".dots").find(".dot").removeClass("active");
    $slider.find(".dots").find(".dot").eq(nextSlide).addClass("active");
    this.$sliderContainer.css({"transform": "translate( -"+totalOffset+"px, 0px)"})
};

Sliderable.prototype.prevSlide = function(){
    var activeItem = this.getActiveSlide(),
        activeItemIndex = activeItem.index(),
        sliderItemTotal = this.$sliderContainer.find(".sliderable-item").length,
        nextSlide = 0;

    if (activeItemIndex - 1 < 0){
        nextSlide = sliderItemTotal - 1;
    }else{
        nextSlide = activeItemIndex - 1;
    }

    var nextSlideSelect = this.$sliderContainer.find(".sliderable-item").eq(nextSlide),
        itemContainerOffset = this.$sliderContainer.offset().left,
        totalOffset = nextSlideSelect.offset().left - itemContainerOffset

    this.getActiveSlide().removeClass("active");
    nextSlideSelect.addClass("active");
    $slider.find(".dots").find(".dot").removeClass("active");
    $slider.find(".dots").find(".dot").eq(nextSlide).addClass("active");
    this.$sliderContainer.css({"transform": "translate( -"+totalOffset+"px, 0px)"})
};

Sliderable.prototype.makeDots = function(){
    if( this.settings.dots === false ){
        return;
    }

    var activeItem = this.getActiveSlide(),
        activeItemIndex = activeItem.index(),
        sliderItemTotal = this.$sliderContainer.find(".sliderable-item").length;

    for (i = 0; i < sliderItemTotal; i++){
        $slider.find(".dots").append("<div class='dot'></div>")
    }

    $slider.find(".dots").find(".dot").eq(activeItemIndex).addClass("active")
};

Sliderable.prototype.goToSlide = function( className ){


    var dotIndex = this.$sliderContainer.find( className ).index(),
        totalOffset = this.$sliderContainer.find(".sliderable-item").eq(dotIndex).offset().left - this.$sliderContainer.offset().left;


    this.getActiveSlide().removeClass("active");
    $(className).addClass("active");

    this.$sliderContainer.css({"transform": "translate( -"+totalOffset+"px, 0px)"});
};

Sliderable.prototype.getActiveSlide = function(){
    
  return this.$sliderItem.filter( $('.active') );  
};

module.exports =  Sliderable;
